export default __webpack_public_path__ + "static/media/Iconly-Bold-Profile.b5d19a55.svg";